module.exports = __webpack_public_path__ + "c002894f0434e1e0e95932fbb33ff17d.png";